module.exports = __webpack_public_path__ + "media/images/icons/money-6dc1b1d6072b471b033a90a379c13d00.svg";